import { render, staticRenderFns } from "./TestimoniosVideo.vue?vue&type=template&id=26233731&scoped=true&"
import script from "./TestimoniosVideo.vue?vue&type=script&lang=js&"
export * from "./TestimoniosVideo.vue?vue&type=script&lang=js&"
import style0 from "./TestimoniosVideo.vue?vue&type=style&index=0&id=26233731&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26233731",
  null
  
)

export default component.exports